/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 18th February 2019
 *
 *  Portal Footer
 */
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness3';
import Tooltip from '@material-ui/core/Tooltip';

class Footer extends React.Component {
  render() {
    const { classes } = this.props;
    const { themeType, toggleThemeType } = this.props.store.portalStore.theme;

    return (
      <React.Fragment>
        <Grid container className={classes.container} justify='space-between' direction='row' alignItems='center'>
          <Grid item style={{ width: 48 }}></Grid>
          <Grid item>
            <Typography>
              &copy; {1900 + new Date().getYear()} {' VendorBadge'}
            </Typography>
          </Grid>
          <Grid item className={classes.gridItemThemeToggle}>
            <Tooltip title={themeType === 'light' ? 'Dark Theme' : 'Light Theme'} placement='top-start'>
              <IconButton onClick={toggleThemeType} className={classes.themeButton}>
                {themeType === 'light' ? <DarkIcon /> : <LightIcon />}
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  container: {
    flex: '0 0 auto',
    textAlign: 'center',
    minHeight: '36px',
  },
  copyright: {
    textAlign: 'center',
  },
  themeButton: {
    padding: '10px',
  },
});

export default withRouter(withStyles(styles, { withTheme: true })(inject('store')(observer(Footer))));
